import * as Yup from 'yup';

const multiplesJobsSchema = () => ({
  selectedJobUid: Yup.string(),
});

export default multiplesJobsSchema;
